
const searchModel = {
  type: 1,
  keyword: '',
  viewData: null
}

searchModel.gettype = function() {
  return this.type
}

searchModel.settype = function(v) {
  this.type = v
}

searchModel.getkeyword = function() {
  return this.keyword
}

searchModel.setkeyword = function(v) {
  this.keyword = v
}

export default searchModel
